import React from "react";

const stats = [
  { value: "500+", label: "Atendimentos realizados" },
  { value: "24h", label: "Disponibilidade total" },
  { value: "5★", label: "Avaliação média" },
  { value: "100%", label: "Clientes satisfeitos" },
];

export default function Stats() {
  return (
    <section
      data-testid="stats-section"
      className="relative py-20 bg-[#f3bd0e] text-black overflow-hidden"
    >
      {/* Diagonal accent */}
      <div
        className="absolute inset-0 opacity-10"
        style={{
          backgroundImage:
            "repeating-linear-gradient(-45deg, #000 0px, #000 1px, transparent 1px, transparent 18px)",
        }}
      ></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((s, idx) => (
            <div
              key={s.label}
              data-testid={`stat-${idx}`}
              className="text-center lg:text-left border-l-0 lg:border-l-2 lg:border-black/20 lg:pl-6 first:border-l-0"
            >
              <div className="font-display text-5xl sm:text-6xl lg:text-7xl tracking-tighter leading-none">
                {s.value}
              </div>
              <div className="mt-3 text-[11px] sm:text-xs font-bold uppercase tracking-[0.2em]">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
